import PropTypes from "prop-types";

import DatePickerNative from "../Common/Forms/DatePickerNative";
import FormButtonsForCloseAndSubmit from "../Common/Forms/FormButtonsForCloseAndSubmit";
import TextInput from "../Common/Forms/TextInput";
import TimePickerNative from "../Common/Forms/TimePickerNative";

const InnsynMotorvognFilterForm = (props) => {
  const {
    showSokSpinner,
    innsynMotorvognFilterForm,
    handleOnChange,
    handleOnSubmit,
    handleOnChangeToInitState,
  } = props;
  return (
    <form
      id="motorvogn-filter"
      className="SearchFormDiv"
      onSubmit={handleOnSubmit}
    >
      <div className="SearchFilterOverskrift">Søk etter motorvogn</div>
      <div className="filter-flexbox-container innsyn-motorvogn-filter-flexbox-item">
        <TextInput
          label="Kjennemerke"
          name="kjennemerke"
          onChange={handleOnChange}
          onBlur={(e) =>
            handleOnChange({
              target: {
                name: e.target.name,
                value: e.target.value.replace(/\s/g, ""),
              },
            })
          }
          value={innsynMotorvognFilterForm.kjennemerke}
          validationError={innsynMotorvognFilterForm.kjennemerkeValidationError}
        />
        <DatePickerNative
          id="dato"
          name="dato"
          label="Dato"
          placeholder="Velg"
          onChange={handleOnChange}
          value={innsynMotorvognFilterForm.dato}
          validationError={innsynMotorvognFilterForm.datoValidationError}
        />
        <TimePickerNative
          id="tid"
          name="tid"
          label="Tid"
          placeholder="Velg"
          onChange={handleOnChange}
          value={innsynMotorvognFilterForm.tid}
          validationError={innsynMotorvognFilterForm.tidValidationError}
        />
      </div>
      <div className="understellsnummer-filter-flexbox-container innsyn-motorvogn-filter-flexbox-item">
        <TextInput
          label="Understellsnummer"
          name="understellsnummer"
          onChange={handleOnChange}
          onBlur={(e) =>
            handleOnChange({
              target: {
                name: e.target.name,
                value: e.target.value.replace(/\s/g, ""),
              },
            })
          }
          value={innsynMotorvognFilterForm.understellsnummer}
          validationError={
            innsynMotorvognFilterForm.understellsnummerValidationError
          }
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <FormButtonsForCloseAndSubmit
          closeText="Tilbakestill"
          submitText="Søk"
          onClose={handleOnChangeToInitState}
          onSubmit={handleOnSubmit}
          showCloseSpinner={false}
          showSubmitSpinner={showSokSpinner}
        />
      </div>
    </form>
  );
};

InnsynMotorvognFilterForm.propTypes = {
  showSokSpinner: PropTypes.bool,
  innsynMotorvognFilterForm: PropTypes.shape({
    kjennemerke: PropTypes.string,
    dato: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    tid: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    understellsnummer: PropTypes.string,
    kjennemerkeValidationError: PropTypes.string,
    datoValidationError: PropTypes.string,
    tidValidationError: PropTypes.string,
    understellsnummerValidationError: PropTypes.string,
  }),
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleOnChangeToInitState: PropTypes.func.isRequired,
};

export default InnsynMotorvognFilterForm;
